export const team = [
  {
    id: 'arit',
    name: 'Arit Wongsuphap',
    role: 'Founder & Principal Engineer',
    expertise: 'Distributed Systems · Cloud Architecture',
    initials: 'AW',
    accent: 'from-cyan/40 to-navy-500/50',
    certs: ['AWS Solutions Architect Pro', 'CKA — Kubernetes', '12+ yrs'],
  },
  {
    id: 'nicha',
    name: 'Nicha Phromma',
    role: 'Head of Engineering',
    expertise: 'Backend · API Design · Data',
    initials: 'NP',
    accent: 'from-cyan-glow/40 to-navy-600/50',
    certs: ['PostgreSQL Contributor', 'Node.js Expert', '10+ yrs'],
  },
  {
    id: 'korn',
    name: 'Korn Sirikul',
    role: 'Lead Frontend Architect',
    expertise: 'React · Design Systems · UX',
    initials: 'KS',
    accent: 'from-silver/30 to-cyan-deep/40',
    certs: ['React Community Speaker', 'a11y Specialist', '9+ yrs'],
  },
  {
    id: 'prinya',
    name: 'Prinya Atthakorn',
    role: 'DevOps & Platform Lead',
    expertise: 'Kubernetes · CI/CD · Observability',
    initials: 'PA',
    accent: 'from-cyan/35 to-navy-700/50',
    certs: ['AWS DevOps Pro', 'Terraform Associate', '8+ yrs'],
  },
  {
    id: 'montri',
    name: 'Montri Tantisena',
    role: 'Security & Compliance Lead',
    expertise: 'AppSec · SOC2 · ISO 27001',
    initials: 'MT',
    accent: 'from-cyan-glow/30 to-navy-500/45',
    certs: ['CISSP', 'CEH', 'ISO 27001 LA'],
  },
  {
    id: 'suda',
    name: 'Sada Liamthong',
    role: 'Product & Client Partner',
    expertise: 'Discovery · Delivery · Strategy',
    initials: 'SL',
    accent: 'from-silver/25 to-cyan/35',
    certs: ['PMP', 'Scrum Master', '11+ yrs'],
  },
];
